import FrameworkCourseController from '../../../framework-course.controller';

class Diagram3Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 4;
    this.clearDiagramId = 2
    this.exerciseId = 'exercise-2';
    this.pyramidData = {
      exerciseNumber: 2,
      scheme: {
        model: {
          textarea: 'Eastwood can develop a single core architecture that each Plan could adapt economically to its own market',
        },
        children: [
          {
            model: {
              textarea: 'It would focus on the Plans’ six common business systems',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'It would include access to eleven major functionalities',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'It would be based on a flexible, open, 4-layered architecture',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'It would be implemented smoothly in four phases',
            },
            children: [

            ]
          },
        ],
      },
      scq: {
        's-header': 'Sit, DE, R1-a, R2-a, Sol-a',
        'c-header': 'R1-b, R2-b, Sol-b',
      },
    };
  }

}

export default Diagram3Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram3/diagram3.controller.js